export default __webpack_public_path__ + "ec1bc5377761a7685e6532532944bbd4.svg";